import {useEffect } from "react";
import { useParams } from "react-router-dom";
import { HTTPURL,REQUEST_OPTIONS_NO_HEAD} from "../../constants/matcher";
import { useStateWithCallbackLazy } from 'use-state-with-callback';
import DataLoader from "../../Utils/DataLoader";
import { PDFReader } from 'reactjs-pdf-reader';
import FileViewer from 'react-file-viewer';

const ViewUploadAssignment = () =>
{
    const [courseName, setCourseName] = useStateWithCallbackLazy([]);
    const [image, setImage] = useStateWithCallbackLazy([]);
    const [pdf, setPdf] = useStateWithCallbackLazy([]);
    const [video, setVideo] = useStateWithCallbackLazy([]);
    const [less_assign, setless_assign] = useStateWithCallbackLazy([]);
    const [showResults, setShowResults] = useStateWithCallbackLazy(false);

    let imgIds = [];

    const {assignment_id} = useParams();

    useEffect(() => 
    {
        const lessonDetails = async() => 
        {
            try {
                return await fetch(HTTPURL+'admin/view-upload-assignments/'+assignment_id)
                .then((response) => response.json())
                .then((data) => 
                {
                    // includes()
                    let xls = [];
                    let video = [];
                    let pdf = [];
                    let img = [];
                    data.data[1].map((data) =>
                    {
                        if(
                            data.name.includes('.xlsx') || 
                            data.name.includes('.xls'))
                        {
                            xls.push(data);
                        } else if(
                            data.name.includes('.jpeg') || 
                            data.name.includes('.png') || 
                            data.name.includes('.jpg')) 
                        {
                            img.push(data);
                        } else if(data.name.includes('.pdf')) 
                        {
                            pdf.push(data);
                        } else if(data.name.includes('.mp4')) 
                        {
                            video.push(data);
                        }
                    });
                    setCourseName(data.data[0], () => setShowResults(true));
                    setImage(img, () => setShowResults(true));
                    setPdf(pdf, () => setShowResults(true));
                    setVideo(video, () => setShowResults(true));
                    setless_assign(xls,() => setShowResults(true));
                });
            } catch (error) {
                console.log(error);
            }
        }
        lessonDetails();
    },[]);

    // function for img
    const img_download = async() =>
    {
        try {
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ imgIds: imgIds}),
                responseType: 'blob',
            };
            return await fetch(HTTPURL+'user/download-images',requestOptions)
            .then(response => 
                {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'filename.zip'); 
                    document.body.appendChild(link);
                    link.click();
                }
            );
        } catch (error) {
            console.log(error);
        }
    }

    return (
        <div className="container rounded bg-white mt-5 mb-5">
            <div className="row">
                <div className="col-md-1 border-right">
                </div>
                <div className="col-md-9 border-right">
                    {
                        showResults ? 
                        <div className="p-3 py-5">
                            <div className="d-flex justify-content-between align-items-center mb-3">
                                <h4 className="text-right"><i className="fa-solid fa-circle-info"></i> Uploaded Assignment Details</h4>
                            </div>
                            <div className="row mt-2">
                                <div className="col-md-6">
                                    <label className="form-label" htmlFor="course name">Course Name: {courseName[0]?.course}</label>
                                </div>
                                <div className="col-md-6">
                                    <label className="form-label" htmlFor="lesson name">Lesson Name: {courseName[0]?.lesson_name}</label>
                                </div>
                            </div>
                            <hr/>
                            <div className="row mt-2">
                                <div className="col-md-12">
                                    <h6 className="form-label" htmlFor="course content">Lesson Resources:</h6>
                                            <label className="form-label" htmlFor="image">Image:</label>
                                            {
                                                image.length > 0  ? 
                                            
                                                <div className="d-flex flex-column align-items-center text-center prf-img-set">
                                                    <div className="show-images">
                                                        {
                                                            image && image.map((img,index) => 
                                                            {  
                                                                imgIds.push(img.id);
                                                                return <img key={index} src={HTTPURL+'uploadAssignments/'+img.name} className="rounded-circle mt-5" height="100px" width="100px" /> 
                                                            })
                                                        }
                                                    </div>
                                                    <div className="download-data text-end">
                                                        <button className="btn btn-primary sap-btn-dark" onClick={img_download}> <i className="fa-solid fa-download"></i> download</button>
                                                    </div>
                                                </div>
                                                :
                                                <div className="download-data text-center">
                                                    <span>No Result</span>
                                                </div>
                                            }
                                            <hr/>
                                            <label className="form-label" htmlFor="course name">Pdf:</label>
                                            {
                                                pdf.length > 0 ?
                                            
                                                <div className="d-flex flex-column align-items-center text-center prf-img-set">
                                                    <div className="show-images">
                                                        {
                                                            pdf && pdf.map((pdf,index) =>
                                                            {
                                                                return <PDFReader key={index} url={HTTPURL+'uploadAssignments/'+pdf.name} height="200" width="150" className="rounded-circle mt-5"/>
                                                            })
                                                        }
                                                    </div>
                                                    <div className="download-data text-end">
                                                        <button className="btn btn-primary sap-btn-dark"> <i className="fa-solid fa-download"></i> download</button>
                                                    </div>
                                                </div>  
                                                :
                                                <div className="download-data text-center">
                                                    <span>No Result</span>
                                                </div>
                                            }   
                                            <hr/>
                                            <label className="form-label" htmlFor="Video">Video:</label>
                                            {
                                                video.length > 0 ?

                                                <div className="d-flex flex-column align-items-center text-center prf-img-set">
                                                    <div className="show-images">
                                                        {
                                                            video && video.map((video,index) =>
                                                            {
                                                                return <iframe
                                                                        key={index}
                                                                        src={HTTPURL+'uploadAssignments/'+video.name}
                                                                        width="480" 
                                                                        height="270"
                                                                    />
                                                            })
                                                        }
                                                    </div>
                                                    <div className="download-data text-end">
                                                        <button className="btn btn-primary sap-btn-dark"><i className="fa-solid fa-download"></i> download</button>
                                                    </div>
                                                </div>  
                                                :
                                                <div className="download-data text-center">
                                                    <span>No Result</span>
                                                </div>
                                            }
                                </div>
                            </div>
                            <hr/>
                            <div className="row mt-2">
                                <div className="col-md-12">
                                    <h6 className="form-label" htmlFor="course name">Lesson Assignment:</h6>
                                    {
                                    less_assign.length > 0 ? 
                                        <div className="d-flex flex-column align-items-center prf-img-set">
                                            <div className="show-images">
                                                {
                                                    less_assign && less_assign.map((less_assign,index) =>
                                                    {
                                                        return  <FileViewer 
                                                                key={index}
                                                                fileType="xlsx"
                                                                filePath={HTTPURL+'uploadAssignments/'+less_assign.name}
                                                            />
                                                    })
                                                }
                                            </div>
                                            <div className="download-data text-end">
                                                <button className="btn btn-primary sap-btn-dark" ><i className="fa-solid fa-download"></i> download</button>
                                            </div>
                                        </div>
                                        :
                                        <div className="download-data text-center">
                                            <span>No Result</span>
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                        :
                        <DataLoader />
                    }
                </div>
            </div>
        </div>
    )
}
export default ViewUploadAssignment;